import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatCount } from "@/utils/format";
import { usePlayNotice } from "@/components/feature/PlayNoticeProvider";

export default function VideoCard({ video }: { video: Video }) {
  const { showNotice } = usePlayNotice();

  return (
    <article className="group">
      <div className="relative w-full aspect-video overflow-hidden rounded-lg bg-background-200">
        <Link to={`/detail/${video.id}`} className="block w-full h-full" aria-label={video.title}>
          <img
            src={video.cover}
            alt={video.title}
            title={`${video.title} - 樱桃视频`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-2 left-2 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-label text-background-50">
            {video.categoryName}
          </span>
          <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-label text-background-50">
            {video.duration}
          </span>
          <span className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></span>
        </Link>
        <button
          type="button"
          onClick={() => showNotice(video.title)}
          aria-label={`播放 ${video.title}`}
          className="absolute inset-0 flex items-center justify-center cursor-pointer"
        >
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 scale-90 transition-all duration-300 group-hover:opacity-100 group-hover:scale-100">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </button>
      </div>
      <h3 className="mt-3 text-sm md:text-base font-heading font-semibold leading-snug text-foreground-950 line-clamp-2">
        <Link to={`/detail/${video.id}`} className="hover:text-primary-600 transition-colors">
          {video.title}
        </Link>
      </h3>
      <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
        <span className="truncate">{video.author}</span>
        <span className="whitespace-nowrap">{video.uploadDate}</span>
      </div>
      <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
        <span className="flex items-center">
          <i className="ri-eye-line mr-1"></i>
          {formatCount(video.views)}
        </span>
        <span className="flex items-center">
          <i className="ri-thumb-up-line mr-1"></i>
          {formatCount(video.likes)}
        </span>
      </div>
    </article>
  );
}